import { ExpertToInput } from "../Expert/selection/ExpertToInput";
import { Scrollable } from "../Scrollable/Scrollable";
import { ChatFileManagerProvider } from "../file/ChatFileManager/ChatFileManagerContext";
import { AssistBodyContent } from "./AssistBodyContent";
import { AssistBodyFooter } from "./AssistBodyFooter";
import { AssistBodyHeader } from "./AssistBodyHeader";
import { AssistChatHistoryList } from "./AssistChatHistory";
import { useAssistContext } from "./AssistContext";

type AssistBodyHeaderProps = {
  onMinimize?: () => void;
};

export const AssistBody: React.FC<AssistBodyHeaderProps> = ({ onMinimize }) => {
  const { isExpanded, activeChatUuid } = useAssistContext();

  return (
    <>
      <div className={"bg-background-1 flex h-full flex-1 flex-row"}>
        {isExpanded && (
          <div className="w-1/4 max-w-100 overflow-hidden">
            <AssistChatHistoryList />
          </div>
        )}

        <div className="flex flex-1 flex-col overflow-hidden">
          <AssistBodyHeader onMinimize={onMinimize} />
          {activeChatUuid === null && <ExpertToInput className="px-4" />}
          <AssistBodyContent.TabsContainer />
          <Scrollable
            fromColorClassName="from-background-1"
            outerClassName="flex flex-1 flex-col"
            innerClassName="flex flex-1 flex-col"
            maxShadowHeight={100}
          >
            <AssistBodyContent />
          </Scrollable>
          <AssistBodyContent.PaginationContainer />
          <ChatFileManagerProvider
            groupUuid={undefined}
            kitUuid={undefined}
            chatUuid={activeChatUuid}
          >
            <AssistBodyFooter />
          </ChatFileManagerProvider>
        </div>
      </div>
    </>
  );
};
